import { makeStyles } from 'tss-react/mui';

/**
 * Layout for the Sidekick assistant-message feedback surface — the
 * icon-button row plus the inline freeform feedback card that expands
 * directly below it. The buttons themselves are styled by the shared
 * `useMessageActionButtonStyles`, which `MessageFeedbackRow` merges in.
 *
 * The 8px gap between the bubble and this surface is owned by the
 * parent (`MessageBubble`'s `assistantStack`) so it matches the
 * Figma `response` component and so this row stays context-agnostic
 * when reused.
 */
const useStyles = makeStyles()((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    // 12px between the icon row and the inline feedback form when it
    // is open. Matches the Figma `response` container's `gap-12`.
    gap: theme.spacing(1.5),
    width: '100%',
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.new.spacing.xsmall,
  },
}));

export default useStyles;
